
export default {
  name: 'AttachmentSkeleton',
};
